export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14241.636ad574.jpg";